import React from "react";
import {PaginationLinks} from "./PaginationLinks";
import {PaginationToolbar} from "./PaginationToolbar";
import {useQuery} from "../../../_helpers/SearchParams";
import {useHistory} from "react-router-dom";

export function Pagination(props) {
    const {children, paginationProps} = props;
    let query = useQuery();
    const history = useHistory();

    function handlePageChange(page) {
        history.push(`${history.location.pathname}?page=${page}&limit=${query.get("limit") ? query.get("limit") : ''}`)
    }

    function handleLimitChange(limit) {
        history.push(`${history.location.pathname}?page=${query.get("page") ? query.get("page") : ''}&limit=${limit}`)
    }

    return (
        <>
            {children}
            <div className="d-flex justify-content-between align-items-center flex-wrap">
                <PaginationLinks paginationProps={paginationProps} handlePageChange={handlePageChange} {...props} />
                <PaginationToolbar
                    paginationProps={paginationProps}
                    handleLimitChange={handleLimitChange}
                    {...props}
                />
            </div>
        </>
    );
}
